export default class CreatePromotionAction {
   
    static CREATE_PROMOTION_REQUEST = 'CREATE_PROMOTION_REQUEST';
    static CREATE_PROMOTION_SUCCESS = 'CREATE_PROMOTION_SUCCESS';
    static CREATE_PROMOTION_FAILED = 'CREATE_PROMOTION_FAILED';



    static createPromotion_Request() {
        return {
            type: this.CREATE_PROMOTION_REQUEST
        }
    }

    static createPromotion_Success (data) {
        return {
            type: this.CREATE_PROMOTION_SUCCESS,
            data,
        }
    }

    static createPromotion_Failed (error) {
        return {
            type: this.CREATE_PROMOTION_FAILED,
            error
        }
    }


    // CREATE PROMOTION MTFTS 
    static CREATE_PROMOTION_MTFTS_REQUEST = 'CREATE_PROMOTION_MTFTS_REQUEST';
    static CREATE_PROMOTION_MTFTS_SUCCESS = 'CREATE_PROMOTION_MTFTS_SUCCESS';
    static CREATE_PROMOTION_MTFTS_FAILED = 'CREATE_PROMOTION_MTFTS_FAILED';



    static createPromotion_Mtfts_Request() {
        return {
            type: this.CREATE_PROMOTION_MTFTS_REQUEST
        }
    }

    static createPromotion_Mtfts_Success (data) {
        return {
            type: this.CREATE_PROMOTION_MTFTS_SUCCESS,
            data
        }
    }

    static createPromotion_Mtfts_Failed (error) {
        return {
            type: this.CREATE_PROMOTION_MTFTS_FAILED,
            error
        }
    }

    // New Draft 

    static New_DRAFT_REQUEST = 'New_DRAFT_REQUEST';
    static New_DRAFT_SUCCESS = 'New_DRAFT_SUCCESS';
    static New_DRAFT_FAILED = 'New_DRAFT_FAILED';

    static newDraft_Request() {
        return {
            type: this.New_DRAFT_REQUEST
        }
    }

    static newDraft_Success (data,type) {
        return {
            type: this.New_DRAFT_SUCCESS,
            data,
            formtype:type
        }
    }

    static newDraft_Failed (error) {
        return {
            type: this.New_DRAFT_FAILED,
            error
        }
    }         
     // Save Draft 

    static SAVE_DRAFT_REQUEST = 'SAVE_DRAFT_REQUEST';
    static SAVE_DRAFT_SUCCESS = 'SAVE_DRAFT_SUCCESS';
    static SAVE_DRAFT_FAILED = 'SAVE_DRAFT_FAILED';

    static saveDraft_Request() {
        return {
            type: this.SAVE_DRAFT_REQUEST
        }
    }

    static saveDraft_Success (data) {
        return {
            type: this.SAVE_DRAFT_SUCCESS,
            data
        }
    }

    static saveDraft_Failed (error) {
        return {
            type: this.SAVE_DRAFT_FAILED,
            error
        }
    }          

     // All Enum 

    static GET_ALL_ENUM_REQUEST = 'GET_ALL_ENUM_REQUEST';
    static GET_ALL_ENUM_SUCCESS = 'GET_ALL_ENUM_SUCCESS';
    static GET_ALL_ENUM_FAILED = 'GET_ALL_ENUM_FAILED';

    static getallEnum_Request() {
        return {
            type: this.GET_ALL_ENUM_REQUEST
        }
    }

    static getallEnum_Success (data) {
        return {
            type: this.GET_ALL_ENUM_SUCCESS,
            data
        }
    }

    static getallEnum_Failed (error) {
        return {
            type: this.GET_ALL_ENUM_FAILED,
            error
        }
    }          

    // Post Calculate Preopso

    static POST_CALCULATE_PREOPSO_REQUEST = 'POST_CALCULATE_PREOPSO_REQUEST';
    static POST_CALCULATE_PREOPSO_SUCCESS = 'POST_CALCULATE_PREOPSO_SUCCESS';
    static POST_CALCULATE_PREOPSO_FAILED = 'POST_CALCULATE_PREOPSO_FAILED';

    static calculate_preOpso_Request() {
        return {
            type: this.POST_CALCULATE_PREOPSO_REQUEST
        }
    }

    static calculate_preOpso_Success (data) {
        return {
            type: this.POST_CALCULATE_PREOPSO_SUCCESS,
            data
        }
    }

    static calculate_preOpso_Failed (error) {
        return {
            type: this.POST_CALCULATE_PREOPSO_FAILED,
            error
        }
    }          

     // Post Calculate Preopso

     static POST_NEWPROJECT_PREOPSO_REQUEST = 'POST_NEWPROJECT_PREOPSO_REQUEST';
     static POST_NEWPROJECT_PREOPSO_SUCCESS = 'POST_NEWPROJECT_PREOPSO_SUCCESS';
     static POST_NEWPROJECT_PREOPSO_FAILED = 'POST_NEWPROJECT_PREOPSO_FAILED';
 
     static newProject_preOpso_Request() {
         return {
             type: this.POST_NEWPROJECT_PREOPSO_REQUEST
         }
     }
 
     static newProject_preOpso_Success (data) {
         return {
             type: this.POST_NEWPROJECT_PREOPSO_SUCCESS,
             data
         }
     }
 
     static newProject_preOpso_Failed (error) {
         return {
             type: this.POST_NEWPROJECT_PREOPSO_FAILED,
             error
         }
     } 
     
     // push to dwh
     static PUSH_TO_DWH_REQUEST = 'PUSH_TO_DWH_REQUEST';
     static PUSH_TO_DWH_SUCCESS = 'PUSH_TO_DWH_SUCCESS';
     static PUSH_TO_DWH_FAILED = 'PUSH_TO_DWH_FAILED';
 
 
 
     static push_to_dwh_Request(data) {
         return {
             type: this.PUSH_TO_DWH_REQUEST,
             data

         }
     }
 
     static push_to_dwh_Success (data) {
         return {
             type: this.PUSH_TO_DWH_SUCCESS,
             data
         }
     }
 
     static push_to_dwh_Failed (error) {
         return {
             type: this.PUSH_TO_DWH_FAILED,
             error
         }
     }
}
